export default __webpack_public_path__ + "static/media/electron.115faec0.png";